// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5996ebd","239":"75e1ef32","455":"b4482ae7"}[chunkId] + ".chunk.js";
};